import React, { useState } from 'react';

const parseFindings = (input: string) => {
  // Simple parser: split by newlines, filter non-empty lines
  return input
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(line => line.length > 0);
};

const BacpacFindingsReport: React.FC = () => {
  const [rawInput, setRawInput] = useState('');
  const [findings, setFindings] = useState<string[]>([]);

  const handleParse = () => {
    setFindings(parseFindings(rawInput));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="max-w-3xl mx-auto p-8 bg-white rounded shadow">
      <h1 className="text-2xl font-bold mb-4">Bacpac Error Findings Report</h1>
      <textarea
        className="w-full h-40 border rounded p-2 mb-4"
        placeholder="Paste bacpac error/findings output here..."
        value={rawInput}
        onChange={e => setRawInput(e.target.value)}
      />
      <div className="mb-4">
        <button
          className="px-4 py-2 bg-shiftleft-600 text-white rounded mr-2"
          onClick={handleParse}
        >
          Parse Findings
        </button>
        <button
          className="px-4 py-2 bg-gray-600 text-white rounded"
          onClick={handlePrint}
        >
          Print
        </button>
      </div>
      {findings.length > 0 && (
        <div className="print:bg-white print:text-black">
          <h2 className="text-xl font-semibold mb-2">Findings</h2>
          <ol className="list-decimal pl-6">
            {findings.map((f, i) => (
              <li key={i} className="mb-2">{f}</li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

export default BacpacFindingsReport;
